import React, { Component } from 'react';

import { Grid, Card, CardHeader, Avatar, Switch } from '@material-ui/core';
import { BarChartTwoTone, DonutLarge, Timeline } from '@material-ui/icons';
import PropTypes from 'prop-types';

import GraphCard from './GraphCard';
import BarGraph from './BarGraph';
import LineGraph from './LineGraph';
import PlannedCost from './PlannedCost';

import '../../assets/stylesheets/DashboardView.css';

import i18n from '../../i18n';

class StudioProgressInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandView: false,
    };
  }

  handleExpandClick = () => {
    this.setState((prevState) => ({ expandView: !prevState.expandView }));
  };

  generateBarGraphCard = (title, data) => {
    const { formattedSelectedDateRange, indexBy, keys } = this.props;
    return (
      <GraphCard
        title={title}
        subheader={formattedSelectedDateRange}
        graphAvatar={<BarChartTwoTone />}
        contentWrapperStyle={data.length ? 'progressBarGraph' : ''}
        content={
          data.length ? (
            <BarGraph keys={keys} indexBy={indexBy} data={data} />
          ) : (
            <p className="centerText">{i18n.t('noData')}</p>
          )
        }
      />
    );
  };

  generateLineGraphCard = (title, data) => {
    const { formattedSelectedDateRange } = this.props;
    // This to check if data is present to display line graph
    const showLineGraphData = data[0].data.length && data[1].data.length;
    return (
      <GraphCard
        title={title}
        subheader={formattedSelectedDateRange}
        graphAvatar={<Timeline />}
        contentWrapperStyle={data.length ? 'progressLineGraph' : ''}
        content={
          showLineGraphData ? (
            <LineGraph data={data} useCustomColors />
          ) : (
            <p className="centerText">{i18n.t('noData')}</p>
          )
        }
      />
    );
  };

  render() {
    const { expandView } = this.state;
    const {
      studioRTWData,
      totalMaleStudioRTWData,
      studioMFLData,
      totalMaleStudioMFLData,
      actualVsPlannedRangeDataStudio,
      fullTimeCost,
      freelancerCost,
      contractorCost,
      totalFemaleStudioRTWData,
      totalFemaleStudioMFLData,
      discrepancy,
    } = this.props;

    return (
      <Grid container>
        <Grid item xs={6}>
          <Card className="cardContainer">
            <CardHeader
              avatar={
                <Avatar className="cardAvatar" aria-label="progress-info-icon">
                  <DonutLarge color="secondary" />
                </Avatar>
              }
              action={
                <Switch
                  checked={expandView}
                  onChange={this.handleExpandClick}
                  color="secondary"
                  inputProps={{ 'aria-label': 'primary checkbox' }}
                />
              }
              title={i18n.t('dashboard:studioProgressInfo')}
              subheader={i18n.t('dashboard:studioProgressInfoSubtitle')}
            />
          </Card>
        </Grid>
        <Grid item xs={6} />

        <Grid item xs={6}>
          <PlannedCost
            fullTimeCost={fullTimeCost}
            freelancerCost={freelancerCost}
            contractorCost={contractorCost}
            discrepancy={discrepancy}
          />
        </Grid>
        <Grid item xs={6} />

        {!expandView ? (
          <>
            <Grid item xs={4}>
              {this.generateBarGraphCard(
                i18n.t('dashboard:avpRTWAllStudiosMale'),
                totalMaleStudioRTWData
              )}
            </Grid>
            <Grid item xs={4}>
              {this.generateBarGraphCard(
                i18n.t('dashboard:avpMFLAllStudiosMale'),
                totalMaleStudioMFLData
              )}
            </Grid>
            <Grid item xs={4}>
              {this.generateBarGraphCard(
                i18n.t('dashboard:avpRTWAllStudiosFemale'),
                totalFemaleStudioRTWData
              )}
            </Grid>
            <Grid item xs={4}>
              {this.generateBarGraphCard(
                i18n.t('dashboard:avpMFLAllStudiosFemale'),
                totalFemaleStudioMFLData
              )}
            </Grid>
          </>
        ) : (
          <>
            <Grid item xs={12}>
              {this.generateBarGraphCard(
                i18n.t('dashboard:avpRTWPerStudio'),
                studioRTWData
              )}
            </Grid>
            <Grid item xs={12}>
              {this.generateBarGraphCard(
                i18n.t('dashboard:avpMFLPerStudio'),
                studioMFLData
              )}
            </Grid>
          </>
        )}
        <Grid item xs={12}>
          {this.generateLineGraphCard(
            i18n.t('dashboard:avpAcrossDays'),
            actualVsPlannedRangeDataStudio
          )}
        </Grid>
      </Grid>
    );
  }
}

StudioProgressInfo.propTypes = {
  studioRTWData: PropTypes.arrayOf(PropTypes.object).isRequired,
  totalMaleStudioRTWData: PropTypes.arrayOf(PropTypes.object).isRequired,
  keys: PropTypes.arrayOf(PropTypes.string).isRequired,
  studioMFLData: PropTypes.arrayOf(PropTypes.object).isRequired,
  totalMaleStudioMFLData: PropTypes.arrayOf(PropTypes.object).isRequired,
  indexBy: PropTypes.string.isRequired,
  formattedSelectedDateRange: PropTypes.string.isRequired,
  actualVsPlannedRangeDataStudio: PropTypes.arrayOf(PropTypes.object)
    .isRequired,
  fullTimeCost: PropTypes.number.isRequired,
  freelancerCost: PropTypes.number.isRequired,
  contractorCost: PropTypes.number.isRequired,
  totalFemaleStudioRTWData: PropTypes.arrayOf(PropTypes.object).isRequired,
  totalFemaleStudioMFLData: PropTypes.arrayOf(PropTypes.object).isRequired,
  discrepancy: PropTypes.arrayOf(PropTypes.shape({
    studioEmployeeId: PropTypes.number,
    positionId: PropTypes.number,
    availabilityType: PropTypes.string,
    date: PropTypes.string,
  })).isRequired,
};

export default StudioProgressInfo;
